import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-social-signin-register-number-old',
  templateUrl: './social-signin-register-number-old.component.html',
  styleUrls: ['./social-signin-register-number-old.component.scss']
})
export class SocialSigninRegisterNumberOldComponent implements OnInit {

    countryCode: any;
    selectedCountryCode: any;
    url: string;
    phoneNum : any = null ;
    configJsonObj: any =[];
    cdnURL: string;
  
    constructor(private router:Router, private config: ConfigService, private loginService:LoginService, public toasterService:ToasterService) {
      this.config.getLocalStorageData();
     }
  
    ngOnInit() {
      this.getConuntryData();
      this.url = this.config.baseUrl + '/ImagePath/' + this.config._tid ; 
    }
  
    onlyNumber(evt) {
      
      //this.checkLength(evt.value.length);
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
  
    
   /**To get Country codes */
   getConuntryData() {
    this.loginService.getCountryCode(this.constructor.name).subscribe(result => {
      console.log(result)
    if(result['message'].code == 0){
      this.countryCode = result['data']['Country_MsT'];
      this.countryCode.forEach(element => {
        element.country_TEL_Code = '+' + element.country_TEL_Code.toString();
        if(element.country_Name == 'India' || element.country_Name == 'INDIA'){
          this.selectedCountryCode = element.Id ;
        }
      })
    }else{
      this.toasterService.pop('error', result['message'].message)
    }
    })

  }

  sendOTP(e) {

    let result = e.validationGroup.validate();
    if(result.isValid){

      this.loginService.verifyMobileSocialSignup(this.phoneNum, this.selectedCountryCode ,this.constructor.name).subscribe(result => {
        console.log(result);
         
        if(result['message'].code == 0){

          this.loginService.sendOTPForSignUp(this.phoneNum, this.selectedCountryCode,this.constructor.name).subscribe(result => {
            console.log(result);
      
            if(result['message'].code == 0){
              this.toasterService.pop("success", "OTP Sent Successfully!");
              //this.phoneNum, this.selectedCountryCode 
              this.config.userDetails["mobileNumber"] = this.phoneNum;
              this.config.userDetails["countryCode"] = this.selectedCountryCode;
              console.log("user data", this.config.userDetails)
              this.router.navigate(['social-signin-verify-otp']);
            }else if(result['message'].code == 1){
              this.toasterService.pop("error", result['message'].message) //Authtoken Invalid
            }else if(result['message'].code == 1005){
              this.toasterService.pop("error","Authtoken not valid!")
            }else if(result['message'].code == 4006){ //1109
              this.toasterService.pop("error","Requested data not found!")
            }else{
              this.toasterService.pop(result['message'].message);
            }
           })
        }else{ //
          this.toasterService.pop("error",result['message'].message);
        }
       })
      
    }
    
  }
  
  }
  
